import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useBlocker } from 'react-router';


// Replacement for react-router v5 <Prompt>: asks for confirmation before
// leaving the page while `when` is true.
const Prompt = ({ when, message }) => {
  const shouldBlock = useCallback(
    ({ currentLocation, nextLocation }) => when && (
      currentLocation.pathname !== nextLocation.pathname
      || currentLocation.search !== nextLocation.search
    ),
    [when],
  );
  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      if (window.confirm(message)) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker, message]);

  return null;
};

Prompt.propTypes = {
  when: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default Prompt;
